


















/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop } from 'vue-property-decorator'
import { container, cid, inject } from 'inversify-props'
import API from '@core/services/API'
import { isEmpty } from 'lodash/fp'
import AppForm from '@core/components/AppForm.vue'
import AppDialog from '@core/components/AppDialog.vue'
import KYCForm from '@master/model/kyc-form/KYCForm'
import { IDateService } from '@master/services/IDateService'
import FullPersonalDetails from '@master/model/kyc-form/PersonalDetails'
import { TitleOptions } from '@core/pages/client-management/model/ClientProfile'

const dateService = container.get<IDateService>(cid.IDateService)

@Component({
  components: {
    AppForm,
    AppDialog
  }
})
export default class AppNewClientManual extends Vue {
  @Prop({ default: false }) readonly hideActionButtons?: boolean
  @Prop() readonly model: KYCForm

  @inject()
  private $api: API

  get structures () {
    return [
      {
        label: 'Title',
        key: 'title',
        options: TitleOptions
      },
      {
        label: 'Name',
        key: 'name'
      },
      {
        label: 'NRIC',
        key: 'nric'
      },
      {
        label: 'Contact Mobile',
        key: 'contactMobile'
      }
    ]
  }

  get client1PersonalDetails (): FullPersonalDetails {
    return this.model ? this.model.client1 as unknown as FullPersonalDetails : new FullPersonalDetails('client_0', dateService)
    // return this.model ? this.model.client1 as unknown as PersonalDetailsCustom : cloneDeep(this.personalDetailsModel)
  }

  get client2PersonalDetails (): FullPersonalDetails {
    return this.model ? this.model.client2 as unknown as FullPersonalDetails : new FullPersonalDetails('client_1', dateService)
    // return this.model ? this.model.client2 as unknown as PersonalDetailsCustom : cloneDeep(this.personalDetailsModel)
  }

  get currentUser () {
    return this.$store.getters.currentUser
  }

  async createClient () {
    const gender = (title) => {
      if (title === 'mr') return 'male'
      if (['mrs', 'mdm', 'miss'].includes(title)) return 'female'
      return ''
    }
    const meta = {
      ma_name: this.client1PersonalDetails.name,
      ma_nric: this.client1PersonalDetails.nric,
      ma_title: this.client1PersonalDetails.title,
      ma_gender: gender(this.client1PersonalDetails.title),
      ma_contact_mobile: this.client1PersonalDetails.contactMobile,
      ja_name: this.client2PersonalDetails.name,
      ja_nric: this.client2PersonalDetails.nric,
      ja_title: this.client2PersonalDetails.title,
      ja_gender: gender(this.client2PersonalDetails.title),
      ja_contact_mobile: this.client2PersonalDetails.contactMobile,
      ja_included: !isEmpty(this.client2PersonalDetails.name) || !isEmpty(this.client2PersonalDetails.nric),
      adviser_oid: this.currentUser.accountID,
      adviser_name: this.currentUser.fullname,
      adviser_fa_code: this.currentUser.company_code,
      adviser_mas_rep_no: this.currentUser.mas_repno,
      important_notice_list: this.currentUser.adviser_products ? JSON.parse(this.currentUser.adviser_products) : [],
      important_notice_others: this.currentUser?.other_adviser_products,
      review_date: (new Date()).getTime(),
      kyc_status: 'new'
    }
    const response = await this.$api.kycForm.meta({
      _oid: 'new',
      meta: JSON.stringify(meta)
    })
    window.location.href = '/live/kyc-form/' + response.updateMeta._oid
  }
}
